import React from 'react';

export default function EmailPreferences() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-indigo-700 mb-4">Email Preferences</h1>
      <p className="text-gray-700">
        Configure notification settings, email templates, and delivery preferences.
      </p>
    </div>
  );
}
